module.exports = __webpack_public_path__ + "static/media/after_default.52a90d29.mp3";